import View from "../account/views/auth/EmailSave";
import components from "./components.js";
components.define("js-FormLogin", View);